import { FormikSwitchField } from 'lib/components/formik/FormikSwitchField';
import React from 'react';
import {
  RowWrapper,
  Section,
  SectionTitle,
  UserFormProps,
} from '../../../components/AdminFormComponents';

export const CodirectUserSection = (props: UserFormProps) => {
  const { values, setFieldValue, isSubmitting } = props;

  return (
    <Section id='codirectUserSection'>
      <SectionTitle>CDP</SectionTitle>
      <RowWrapper>
        <FormikSwitchField
          wrapper={{ margin: '0 0 16px 0' }}
          name='codirectUser'
          label='Mark as CDP User'
          onChange={() => {
            setFieldValue(`codirectUser`, !values.codirectUser);
          }}
          readOnly={isSubmitting}
        />
      </RowWrapper>
    </Section>
  );
};
